import update from 'immutability-helper'
import {zip} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'

import Select from '../Select'

import StatusIcon from '../StatusIcon'

const useStyles = makeStyles(matchingStyles)

export default function Matching ({assessment, context, question}) {

  const classes = useStyles()

  const {translate} = context

  const {answers = {}} = assessment 
  const answer = answers[question.id] || {}

  const terms = answer.terms.map((term, index) => {
    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.selectAnswer)} size="small">
        <Box className={classes.answer}>&nbsp;</Box>
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.termHtml)} dangerouslySetInnerHTML={{__html: term.term || ''}} />
    </React.Fragment>)
  })

  const definitions = answer.definitions.map(({definition}, index) => {
    const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.definitionIndex, {selected: answer.selected.indexOf(index) > -1})} size="small">
        {answerIndex})
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.definitionValue)} dangerouslySetInnerHTML={{__html: definition || ''}} />
    </React.Fragment>)
  })

  return (
  <Box className={classes.root}>
    <TableContainer component={Box} className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableBody>{
          zip(terms, definitions).map(([term, definition], index) => {
            return (
              <TableRow key={index} className={classes.pair}>
                {term}
                {definition}
              </TableRow>
            )
          })}</TableBody>
     </Table>
   </TableContainer>
  </Box>
  )
}

function matchingStyles (theme) {
  return {
    root: {
      display: 'flex',
      marginTop: 10,
      flexGrow: 1
    },
    tableContainer: {
      flexShrink: 0,
      maxWidth: 1280,
      display: 'flex',
      fontSize: '11pt',
    },
    cell: {
      borderBottom: 0,
      padding: '16px 0',
      verticalAlign: 'top'
    },
    selectAnswer: {
      width: 20
    },
    answer: {
      width: 20,
      maxWidth: 20,
      borderBottom: 'solid 1px black',
      flexGrow: 0,
    },
    definitionIndex: {
      width: 20,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 20
    },
    table: {
      maxWidth: 1280
    },
    term: {
      display: 'flex'
    },
    termHtml: {
      paddingLeft: 10,
      '& > p': {
        margin: 0
      }
    },
    definitionValue: {
      paddingLeft: 0,
      '& > p': {
        margin: 0
      }
    }
  }
}
